
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChangelogDialogComponent } from './changelog-dialog/changelog-dialog.component';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableComponent } from './data-table/data-table.component';
import { CurrencyInputDirective } from './directives/currency-input.directive';
import { FileUploadDropzoneComponent } from './file-upload-dropzone/file-upload-dropzone.component';
import { SearchableSelectComponent } from './searchable-select/searchable-select.component';
import { FiscalYearNavigatorComponent } from './fiscal-year-navigator/fiscal-year-navigator.component';
import { CollapsibleSectionComponent } from './collapsible-section/collapsible-section.component';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        FormsModule,
        NgSelectModule,
        ChangelogDialogComponent,
        DataTableComponent,
        CurrencyInputDirective,
        NotificationDialogComponent,
        FileUploadDropzoneComponent,
        SearchableSelectComponent,
        FiscalYearNavigatorComponent,
        CollapsibleSectionComponent
    ],
  exports: [
    ChangelogDialogComponent,
    DataTableComponent,
    CurrencyInputDirective,
    NotificationDialogComponent,
    FileUploadDropzoneComponent,
    SearchableSelectComponent,
    FiscalYearNavigatorComponent,
    CollapsibleSectionComponent
  ]
})
export class SharedModule {}
